import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
/**
 * 下拉组件，继承Base
 * @module $ui/components/my-select
 */

import { Select, Option, OptionGroup } from 'element-ui';
import Base from '../Base';

/**
 * 插槽
 * @member slots
 * @property {string} [option] 作用域插槽，参数: item 数据项，index 索引
 */
export default {
  name: 'MySelect',
  mixins: [Base],
  components: {
    Select: Select,
    Option: Option,
    OptionGroup: OptionGroup
  },
  /**
   * 通用参数之外的扩展参数
   * @member props
   * @property {Array} [group] 分组，数据项字段包括 id, label, disabled, options 中的 parentId 字段与分组id相等即标识选项在该分组下
   */
  props: {
    value: [String, Number, Boolean, Array],
    // 分组 [{label, disabled, id}]
    group: {
      type: Array
    }
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      if (this.props && this.props.multiple) {
        return [];
      }
      return '';
    },
    getOptionsByGroupId: function getOptionsByGroupId(groupId) {
      if (!this.currentOptions) return [];
      var parentId = this.keyMap.parentId;
      return this.currentOptions.filter(function (item) {
        return item[parentId] === groupId;
      });
    },
    renderOptions: function renderOptions(options, isDisabled) {
      var _this = this;
      var h = this.$createElement;
      if (!options) return [];
      var scopedSlots = function scopedSlots(opt, index) {
        return _this.$scopedSlots.option ? _this.$scopedSlots.option({
          item: opt,
          index: index
        }) : opt[label];
      };
      var _this$keyMap = this.keyMap,
        label = _this$keyMap.label,
        value = _this$keyMap.value,
        disabled = _this$keyMap.disabled;
      return options.map(function (item, index) {
        var opt = {
          label: item[label],
          value: item[value],
          disabled: isDisabled || item[disabled]
        };
        return h(Option, {
          "props": _objectSpread({}, opt)
        }, [scopedSlots(opt, index)]);
      });
    },
    renderItem: function renderItem() {
      var _this2 = this;
      var h = this.$createElement;
      if (!this.group) return this.renderOptions(this.currentOptions);
      return this.group.map(function (g) {
        var opts = _this2.getOptionsByGroupId(g.id);
        return h(OptionGroup, {
          "attrs": {
            "label": g.label,
            "disabled": g.disabled
          }
        }, [_this2.renderOptions(opts, g.disabled)]);
      });
    }
  },
  render: function render() {
    var _this3 = this;
    var h = arguments[0];
    var vnode = h(Select, {
      "ref": 'comp',
      "class": 'my-select',
      "props": _objectSpread({}, this.innerProps),
      "on": _objectSpread({}, this.$listeners),
      "attrs": _objectSpread({}, this.innerProps),
      "model": {
        value: _this3.fieldValue,
        callback: function callback($$v) {
          _this3.fieldValue = $$v;
        }
      }
    }, [this.renderItem()]);
    return this.renderComponent(vnode);
  },
  mounted: function mounted() {
    this.extendMethods(this.$refs.comp, ['focus', 'blur']);
  }
};